import {PermissionType} from '@hconnect/apiclient'
import {usePermissionsParsedQuery} from '@hproduce/permissions'

// This is specific behavior for RCFA admin - it is plant scoped in permissions but global in usage
// to be removed once RCFA permissions are refactored
export const useHasRcfaAdminRole = () => {
  const {data: permissions} = usePermissionsParsedQuery()
  const adminPermission = 'ADMINISTRATE_ROOT_CAUSE_FAILURE_ANALYSES' as PermissionType

  return permissions?.some((perm) => perm.permissionType === adminPermission) || false
}
